import { NgModule } from '@angular/core';
import { CalendarMyFlexLayoutDirective } from './my-flex-layout.directive';

@NgModule({
  imports: [CalendarMyFlexLayoutDirective],
  exports: [CalendarMyFlexLayoutDirective],
})
export class CalendarFlexLayoutDirectiveModule {}
